import { render, staticRenderFns } from "./FullPage.vue?vue&type=template&id=48d8544a&"
import script from "./FullPage.vue?vue&type=script&lang=ts&"
export * from "./FullPage.vue?vue&type=script&lang=ts&"
import style0 from "./FullPage.vue?vue&type=style&index=0&id=48d8544a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports